import React, { createContext, useContext, ReactNode } from 'react';

interface BadgeContextType {
  updateBadgeData: () => Promise<void>;
}

const BadgeContext = createContext<BadgeContextType | undefined>(undefined);

export const useBadgeContext = () => {
  const context = useContext(BadgeContext);
  if (context === undefined) {
    throw new Error('useBadgeContext must be used within a BadgeProvider');
  }
  return context;
};

interface BadgeProviderProps {
  children: ReactNode;
  updateBadgeData: () => Promise<void>;
}

export const BadgeProvider: React.FC<BadgeProviderProps> = ({ children, updateBadgeData }) => {
  return (
    <BadgeContext.Provider value={{ updateBadgeData }}>
      {children}
    </BadgeContext.Provider>
  );
};
